<ion-card class="card-custom">
  <ion-card-header>
    <ion-card-title>
      {{ 'dashboard.assessmentProcess' | translate }}
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <ul class="assignment-progress">
      <li
        *ngFor="let process of processes"
        [ngClass]="{
          'active primary':  process.status === ProcessStatusEnum.WaitingInput,
          'success':  process.status === ProcessStatusEnum.AllowedViewing,
          'danger':  process.status === ProcessStatusEnum.Declined,
          'warning':  process.status === ProcessStatusEnum.AllowedViewingWithWarnings
        }"
      >
        <ion-item lines="none">
          <ion-label>
            <h2 class="ion-text-wrap">{{ getProcessTitle(process) }}</h2>
            <p>
              <span>
                {{ process.startsAtString }} - {{ process.endsAtString }}
              </span>
              <span *ngIf=" process.obs" >
                <ion-text [color]="getStatusColor(process.status)" >
                  <ion-icon class="bp-circle"></ion-icon> {{ process.obs | translate }}
                </ion-text>
              </span>
            </p>
          </ion-label>

          <ng-container *ngIf="process.status !== ProcessStatusEnum.NotEnabled" >
            <ion-button *ngIf="!process.anonymousReport || !isImpersonated" mode="ios" slot="end"
              [color]="getStatusColor(process.status)"
              (click)="triggerAction(process.cycleProcessConfigId, process.processType, process.processId)" >
              {{ getButtonText(process.status) }}
            </ion-button>
          </ng-container>
        </ion-item>
      </li>
    </ul>
  </ion-card-content>
</ion-card>

